import React from 'react';

const PrivacyPolicy = () => {
  const h2Style = {fontFamily:'var(--font-display)',fontSize:'1.25rem',fontWeight:700,letterSpacing:'-0.5px',color:'var(--text-primary)',margin:'32px 0 10px'};
  const pStyle = {fontFamily:'var(--font-body)',fontSize:'0.9375rem',color:'var(--text-secondary)',lineHeight:1.75,margin:'0 0 12px'};
  const ulStyle = {fontFamily:'var(--font-body)',fontSize:'0.9375rem',color:'var(--text-secondary)',lineHeight:1.75,paddingLeft:'20px',margin:'0 0 12px'};
  const linkStyle = {color:'var(--accent)',textDecoration:'none'};

  return (
    <div style={{minHeight:'100vh',background:'var(--surface-200)',padding:'64px 24px'}}>
      <div style={{maxWidth:'680px',margin:'0 auto'}}>
        <p style={{fontFamily:'var(--font-mono)',fontSize:'0.6875rem',textTransform:'uppercase',letterSpacing:'0.1em',color:'var(--text-tertiary)',margin:'0 0 12px'}}>Legal</p>
        <h1 style={{fontFamily:'var(--font-display)',fontSize:'clamp(1.75rem,4vw,2.75rem)',fontWeight:700,letterSpacing:'-1.5px',color:'var(--text-primary)',margin:'0 0 8px',lineHeight:1.1}}>Privacy Policy</h1>
        <p style={{fontFamily:'var(--font-mono)',fontSize:'0.75rem',color:'var(--text-tertiary)',margin:'0 0 40px'}}>Next Level Websites</p>
        <div style={{background:'var(--surface-100)',border:'1px solid var(--border)',borderRadius:'var(--radius-md)',padding:'40px'}}>
          <h2 style={h2Style}>1. Information We Collect</h2>
          <p style={pStyle}>We may collect the following information when you submit a form:</p>
          <ul style={ulStyle}>
            <li>Your name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Business name and details</li>
            <li>Project preferences or budget</li>
          </ul>
          <h2 style={h2Style}>2. How We Use Your Information</h2>
          <p style={pStyle}>We use your information to:</p>
          <ul style={ulStyle}>
            <li>Contact you about your inquiry</li>
            <li>Better understand your business needs</li>
            <li>Provide services or send relevant follow-ups</li>
          </ul>
          <h2 style={h2Style}>3. How We Protect Your Information</h2>
          <p style={pStyle}>We implement reasonable security measures to protect your data and ensure it is not lost, misused, accessed, disclosed, or altered.</p>
          <h2 style={h2Style}>4. Sharing Your Information</h2>
          <p style={pStyle}>We do <strong>not</strong> sell or rent your personal information. We may only share your data with trusted service providers (e.g. email platforms) to help us follow up with your request.</p>
          <h2 style={h2Style}>5. Your Consent</h2>
          <p style={pStyle}>By submitting a form or interacting with our ads, you consent to this Privacy Policy.</p>
          <h2 style={h2Style}>6. Contact Us</h2>
          <p style={pStyle}>If you have any questions about this Privacy Policy, please contact us at:</p>
          <p style={pStyle}><strong>Email:</strong> <a href="mailto:nextlvlwebsites@gmail.com" style={linkStyle}>nextlvlwebsites@gmail.com</a></p>
          <p style={{...pStyle,marginBottom:0}}><strong>Website:</strong> <a href="https://nextlvlwebsites.com" target="_blank" rel="noopener noreferrer" style={linkStyle}>nextlvlwebsites.com</a></p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
